module.exports = __webpack_public_path__ + "static/media/slideShow3.9d296b80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slideShow/slideShow3.jpg
// module id = 259
// module chunks = 0